export default __webpack_public_path__ + "static/media/non_actif.b07ce76b.svg";